import {
  Box,
  Divider,
} from "@mui/material";
import { StyledDialogTitle } from "../common/StyledDialogTitle";
import BatchShelfTable from "./batchShelfTable";


interface IProps {
  handleClose: () => void;
  initialData?: any;
}

const ViewShelfBranchDetails = ({ handleClose, initialData }: IProps) => {
  
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        bgcolor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
      }}
    >
      <Box
        sx={{
          width: "90vw", 
          maxWidth: "1000px", 
          maxHeight: "90vh", 
          bgcolor: "#fff",
          borderRadius: 2,
          boxShadow: 24,
          position: "relative",
          overflow: "auto",
        }}
      >
        <StyledDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          isDone={false}
        >
        Batch Details
        </StyledDialogTitle>

        <Divider />
        <Box sx={{ p: 2 }}>
          <BatchShelfTable
          shelf={initialData}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ViewShelfBranchDetails;
